import { render, staticRenderFns } from "./EventDetailDialog.vue?vue&type=template&id=42ed2c2f&scoped=true"
import script from "./EventDetailDialog.vue?vue&type=script&lang=js"
export * from "./EventDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./EventDetailDialog.vue?vue&type=style&index=0&id=42ed2c2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ed2c2f",
  null
  
)

export default component.exports